export default "__VITE_ASSET__Bp4uLC1A__"